(function(){
  var st=document.createElement('style');st.textContent='.kk-play{display:none!important}';document.head.appendChild(st);
  /* Produktgalerie: Wischen + Pfeile auf dem grossen Bild */
  function initGallery(sec){
    var main=sec.querySelector('.gallery-main'); if(!main||main.getAttribute('data-kk-init')) return;
    main.setAttribute('data-kk-init','1');
    function go(d){
      var thumbs=sec.querySelectorAll('[data-thumb]'); var n=thumbs.length; if(n<2) return;
      var cur=0; thumbs.forEach(function(th,i){if(th.classList.contains('is-active')) cur=i;});
      var nx=(cur+d+n)%n;
      var btn=sec.querySelector('[data-thumb="'+nx+'"]'); if(!btn) return;
      btn.click();
      var track=sec.querySelector('[data-gs-track]');
      if(track){var li=btn.parentElement;track.scrollTo({left:li.offsetLeft-track.offsetLeft-4,behavior:'smooth'});}
    }
    if(sec.querySelectorAll('[data-thumb]').length>1){
      ['prev','next'].forEach(function(dir){
        var b=document.createElement('button');b.type='button';b.className='kk-arrow kk-arrow--'+dir+' gm-arrow';
        b.setAttribute('aria-label',dir==='prev'?'Vorheriges Bild':'Nächstes Bild');b.textContent=dir==='prev'?'‹':'›';
        b.addEventListener('click',function(e){e.preventDefault();go(dir==='prev'?-1:1);});
        main.appendChild(b);
      });
    }
    var x0=null,y0=null;
    main.addEventListener('touchstart',function(e){var t=e.touches[0];x0=t.clientX;y0=t.clientY;},{passive:true});
    main.addEventListener('touchend',function(e){
      if(x0===null) return;
      var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0; x0=null;
      if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)) return;
      go(dx<0?1:-1);
    },{passive:true});
  }
  /* Buchauswahl: Pfeile fuer den mobilen Slider */
  function initPicker(grid){
    var wrap=grid.parentElement; if(wrap.classList.contains('kk-bp-wrap')) return; wrap.classList.add('kk-bp-wrap');
    ['prev','next'].forEach(function(dir){
      var b=document.createElement('button');b.type='button';b.className='kk-arrow kk-arrow--'+dir+' bp-arrow';
      b.setAttribute('aria-label',dir==='prev'?'Zurück':'Weiter');b.textContent=dir==='prev'?'‹':'›';
      b.addEventListener('click',function(){grid.scrollBy({left:(dir==='prev'?-1:1)*grid.clientWidth*0.8,behavior:'smooth'});});
      wrap.appendChild(b);
    });
  }
  function initAll(){
    document.querySelectorAll('[data-product-section]').forEach(initGallery);
    document.querySelectorAll('.book-picker .book-grid').forEach(initPicker);
  }
  initAll();
  document.addEventListener('shopify:section:load',function(){setTimeout(initAll,50);});
})();
